<script setup>
import { useI18n } from 'vue-i18n';
import { RouterLink } from 'vue-router';

const { t } = useI18n();
</script>

<template>
  <div>
    <h3 class="mb-4 text-lg font-semibold text-warm-800">{{t('footer.links.title')}}</h3>
    <nav class="flex flex-col space-y-2">
      <RouterLink 
        v-for="(link, path) in {
          '/': 'header.nav.home',
          '/services': 'header.nav.services',
          '/about': 'header.nav.about'
        }"
        :key="path"
        :to="path"
        class="transition-colors text-warm-700 hover:text-warm-900"
      >
        {{ t(link) }}
      </RouterLink>
    </nav>
  </div>
</template>